import {
  Variant,
  VariantOption,
} from "src/features/product-modal/model/Variant";

type HasUnselectedVariants = boolean;

export function filterUnselectedVariants(
  variants: Variant[]
): [HasUnselectedVariants, Variant[]] {
  let unselectedVariantFound = false;
  const unselectedVariants = [];

  for (const variant of variants) {
    const selectedOptions = variant.options.filter(
      (option: VariantOption) => option.isSelected
    );
    if (selectedOptions.length === 0) {
      unselectedVariantFound = true;
      unselectedVariants.push(variant);
    }
  }

  return [unselectedVariantFound, unselectedVariants];
}
